import styled from '@emotion/styled';
import React from 'react';

import { css } from 'config/emotionCss';

import colors from 'config/theme/colors';
import { Collapse, Modal as ModalBase } from 'ui/base';

export const bannerCSS = css`
  .ant-modal {
    position: absolute;
    top: unset;
    left: 0px;
    bottom: 0px;
    margin-left: 30px;
    min-height: unset !important;
  }
    
  .ant-modal-container, .ant-modal-body {
      min-height: unset !important;
    }

`;

export const Modal = styled(ModalBase)`
  .ant-modal-container {
    .ant-modal-body {
      line-height: 1.75;
      color: ${colors['@text-color-secondary']};
    }
  }
`;

export const Link = styled.a`
  font-weight: 500;
  text-decoration: underline;
  color: ${colors['@text-color']};
`;

export const Arrow = ({ isActive }) => <span className={isActive ? 'fb-icon--arrow-up' : 'fb-icon--arrow-down'} />;

export const CollapseWrapper = styled(Collapse)`
  background-color: transparent;

  &:last-child > .ant-collapse-item {
    border-bottom: 0;
  }

  .ant-collapse-header * {
    color: #000;
    font-size: 16px;
    font-weight: 700;
  }
`;

export const Wrapper = styled.p`
  padding-left: 24px;
  color: ${colors['@text-color-secondary']};
`;
